import script from "./AdminApp.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminApp.vue?vue&type=script&setup=true&lang=js"

import "./AdminApp.vue?vue&type=style&index=0&id=635b3334&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-635b3334"]])

export default __exports__